import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import sharedModules from '@/shared/store'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
    strict: debug,
    modules: { ...modules, ...sharedModules },
    plugins: [
        createPersistedState({
            paths: ['auth', 'support'],
        }),
    ],
})

export default store
